import React from 'react'
import PropTypes from 'prop-types'
import entityHelper from '../../utils/entityHelper'

const { getUnitData } = entityHelper

const UnitCard = (props) => {
    const {
        inSquad, baseUnit, clickAdd, clickEdit, clickDelete,
    } = props
    const {
        ID, name, avatar,
    } = getUnitData(baseUnit)

    const handlerButton = (label, className, handler) => (
        <button type="button" className={className} onClick={handler}>
            {label}
        </button>
    )

    const clickAddHandler = (!inSquad && clickAdd.enabled)
        ? handlerButton('➕ ADD', 'button--add', () => clickAdd.handler(ID))
        : ''
    const clickEditHandler = (clickEdit.enabled)
        ? handlerButton('⚙️ EDIT', '', () => clickEdit.handler(ID))
        : ''
    const clickDeleteHandler = (inSquad && clickDelete.enabled)
        ? handlerButton('➖ DELETE', 'button--delete', () => clickDelete.handler(ID))
        : ''

    return (
        <div className="unit__card">
            {name}
            {avatar}
            {clickEditHandler}
            {clickAddHandler}
            {clickDeleteHandler}
        </div>
    )
}

UnitCard.propTypes = {
    inSquad: PropTypes.bool.isRequired,
    baseUnit: PropTypes.object.isRequired,
    clickAdd: PropTypes.object.isRequired,
    clickEdit: PropTypes.object.isRequired,
    clickDelete: PropTypes.object.isRequired,
}

export default UnitCard
